export default __webpack_public_path__ + "static/media/banner-introduce.a5df8539.png";